import React from 'react'
import '../scss/accordion.scss'
import style from '../scss/components/FAQ.module.scss'
import Button from './Button'
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from 'react-accessible-accordion'
import { Fade } from "react-awesome-reveal"

const FAQ = () => {
    return (
        <div className={style.Wrapper}>
            <div className={style.Row}>
                <div className={style.Left}>
                    <Accordion preExpanded={['1']}>
                        <AccordionItem uuid={'1'}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    Kas tegu on LIVE koolitusega?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p>
                                    SalonSecrets on eelsalvestatud, ligi 5-tunnine veebikursus,
                                    tänu millele on Sul võimalik koolitust kasvõi mitu korda omale sobival ajal ja kohas vaadata.
                                </p>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem uuid={'2'}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    Kellele see koolitus on mõeldud?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p>
                                    Koolitus on mõeldud kõikidele ilutegijatele ja salongi omanikele sõltumata nende teadmistest või kogemustest salongi müügi ja turunduse valdkonnas.
                                    Enam kui 2000 ilusalongiga üle maailma koostööd tehes oleme avastanud ülimalt efektiivseid salongi kasvatamise
                                    ja tugevamaks muutmise taktikaid, mis on tohutu väärtusega igale ilutegijale.
                                </p>
                                <p>
                                    Seega olenemata sellest, kas oled alles alustav ilutegija või 30-aastase kogemusega salongi omanik, SalonSecretsi 7S mudelist ja 60+ müügi- ja turundusnipist on õppida igaühel.
                                    Lisaks jagab koolitaja Kristo elulisi näiteid ja ka oma kogemusi müügijuhi ja copywriterina ilumaailmas, mis on omaette hindamatu väärtusega!
                                </p>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem uuid={'3'}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    Kes on koolitaja?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p>
                                    Kristo Olli on SalonLife’i müügijuht, copywriter ja koolitaja,
                                    kes on aastatega jõudnud SalonLife’i viia sadade Eesti ja välismaa ilutegijate südametesse nii otsemüügi kui ka koolituste kaudu.
                                </p>
                                <p>
                                    Kristo on spiikrina üles astunud nii “I Am Beautiful” kui ka “Juuksurite konverents” koolituspäevadel,
                                    jagades ilutegijatele näpunäiteid, kuidas konkurentide seast välja paista ja oma salongi bränd uuele tasemele viia.
                                </p>
                                <p>
                                    Kes palju teeb, see palju jõuab – Kristo teeb muuhulgas koostööd mitmete Eesti ja välismaa ettevõtetega, aidates neil luua turundussõnumeid ja kasvatada firmade käivet.
                                    Näiteks aitas Kristo Edu Akadeemial korraldada Eesti läbi aegade suurimat virtuaalsündmust “Päev iseendale”, olles ürituse müügi- ja turundussõnumite looja.
                                </p>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem uuid={'4'}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    Ma pole veel SalonLife’i kasutaja. Kas ma saan ikkagi koolitusest osa võtta?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p>
                                    Ikka saad! SalonSecretsi koolitusvideod ja muud materjalid on küll kõik SalonLife’i keskkonnas, aga see ei eelda, et Sa pead SalonLife’i kasutama.
                                </p>
                                <p>
                                    Selleks, et koolitust vaadata, tuleb Sul küll luua SalonLife’i konto (võtab aega max 30 sekundit pärast ostuprotsessi lõpule viimist),
                                    kuid konto loomine on Sulle tasuta ja ka pärast 14-päevast tasuta prooviperioodi on Sul koolitusele ligipääs olemas.
                                </p>
                            </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem uuid={'5'}>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    Soovin osta. Mida ma järgmiseks tegema pean?
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <p>
                                    Kui Sa juba oled SalonLife’i kasutaja, siis kliki üleval ostukaardi juures nupule “Osta SalonLife’i kasutajana”,
                                    mille järel suunatakse Sind juba SalonLife’i keskkonda, kus saad koolituse eest tasuda sama maksevahendiga, mille oled varasemalt SalonLife’i kuutasude jaoks sisestanud.
                                    Pärast ostu sooritamist suunatakse Sind juba SalonSecretsi koolituslehele.
                                </p>
                                <p>
                                    Kui Sa veel ei ole SalonLife’i kasutaja, siis kliki üleval ostukaardi juures nupule “Osta külalisena”, mille järel suunatakse Sind ostu turvaliselt lõpuni viima Stripe lehel.
                                    Pärast kaardiandmete sisestamist ja ostu sooritamist suunatakse Sind “Aitäh” lehele, kust saad ligipääsu SalonLife’i platvormile ja SalonSecrets koolitusele.
                                </p>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>
                </div>
                <div className={style.Right}>
                    <h6>Kindlusta endale parim hind</h6>
                    <h3>
                        On Sul salongi uuele tasemele viimisel tõsi taga?<br/>
                        Kui jah, siis näeme Salon Secretsi veebikursusel!
                    </h3>
                    <Fade direction={'right'} triggerOnce={true}>
                        <Button inverted mobile16 onClick={() => window.location.href = '#offer'}>
                            Jah, osalen kursusel!
                        </Button>
                    </Fade>
                </div>
            </div>
        </div>
    )
}

export default FAQ
